import React, { PropTypes } from 'react';
import _ from 'lodash';

class PlaceMultiselect extends React.Component {

    constructor(props) {
        super(props);

        var self = this;

        self.state = {
            places: self.props.defaultPlaces || []
        };
    }

    componentDidMount() {
        var self = this,
            options = {};

        if (self.refs.locationInput != null && self.autocomplete == null) {

            if (self.props.restrictToCities === true) {
                options = { types: [ '(cities)' ] };
            }

            self.autocomplete = new google.maps.places.Autocomplete(self.refs.locationInput, options);

            self.autocomplete.addListener('place_changed', self.onPlaceChanged);
        }
    }

    invokeChangeHandler = () => {
        var self = this;

        if (self.props.onChange != null && typeof self.props.onChange === 'function') {
            self.props.onChange(self.state.places);
        }
    }

    onPlaceChanged = () => {
        var self = this,
            place = self.autocomplete.getPlace(),
            name = place.name,
            photos = [];

        if (_.find(self.state.places, p => p.id === place.place_id) != null) {
            self.refs.locationInput.value = '';
            return;
        }

        if (!place.place_id) {
            self.refs.locationInput.value = '';
            return;
        }

        if (!name || name === '') {
            let components = parseAddressComponents(place.address_components);

            if (components.establishment) {
                name = components.establishment;
            }
            else if (components.country) {
                name = (components.locality || components.administrative_area_level_1 || 'Unknown') + ', ' + components.country;
            }
        }

        if (place.photos && place.photos.length) {
            photos = place.photos.map(photo => {
                return photo.getUrl({ maxWidth: 640, maxHeight: 480 });
            });
        }

        place = {
            location: {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng()
            },
            id: place.place_id,
            name: name,
            photos: photos,
            address: place.formatted_address,
            url: place.url
        };

        self.setState({
           ...self.state,
           places: [ ...self.state.places, place ]
        }, () => {
            self.invokeChangeHandler();
        });

        self.refs.locationInput.value = '';
    }

    removePlace = (id) => {
        var self = this;

        self.setState({
            places: _.filter(self.state.places, p => p !== id && p.id !== id)
        }, () => {
            self.invokeChangeHandler();
        });
    }

    onSelectUnresolvedValue = (e) => {
        var self = this,
            value = self.refs.locationInput.value,
            places = self.state.places;

        if (value != null &&
            typeof value === 'string' &&
            value.trim().length > 0 &&
            (places == null || places.indexOf(value) === -1)) {

            places = [...places, value];

            self.setState({
                places
            }, () => {
                self.invokeChangeHandler();
            });
        }

        self.refs.locationInput.value = '';
    }

    render () {
        var self = this;

        return (
            <div className="form-control multiselect-container">
                <ul className="multiselect-item-container">
                    { self.state.places.map((place, index) => {
                        if (!place.id) {
                            return (
                                <li key={ index } className="multiselect-item tag tag-primary">
                                    <i className="fa fa-map-signs multiselect-icon"></i>
                                    { place }
                                    <a href="javascript:void(0)" className="multiselect-item-remove" onClick={ () => self.removePlace(place) }>
                                        <i className="fa fa-remove multiselect-item-remove"></i>
                                    </a>
                                </li>
                            );
                        }

                        return (
                            <li key={ index } className="multiselect-item tag tag-primary">
                                <i className="fa fa-map-marker multiselect-icon"></i>
                                { place.name }
                                <a href="javascript:void(0)" className="multiselect-item-remove" onClick={ () => self.removePlace(place.id) }>
                                    <i className="fa fa-remove multiselect-item-remove"></i>
                                </a>
                            </li>
                        );
                    })}
                    <li className="multiselect-input-container">
                        <input type="text" ref="locationInput" className="multiselect-input" placeholder={ self.props.placeholder } />
                        <i className="fa fa-plus multiselect-input-add" onMouseDown={ self.onSelectUnresolvedValue }></i>
                    </li>
                </ul>
            </div>
        );
    }
};

export default PlaceMultiselect;


// WEBPACK FOOTER //
// ./src/app/components/places/placeMultiselect.jsx